import userActions from './actions';
import getters from './getters';
import userMutations from './mutations';
import storeResourceFactory from '../../libs/storeResourceFactory';

const userStore = storeResourceFactory('user', {
  id: undefined,
  name: undefined,
  email: undefined,
  role: undefined,
  office: undefined,
  isFirstLogged: undefined,
  officeInfo: {},
  dietsInfo: [],
  allergiesInfo: [],
});

const updateFirstLogInStore = storeResourceFactory('isFirstLogin', undefined);

const updateUsersOfficeStore = storeResourceFactory('updateUsersOffice', undefined);

const deleteUsersDietStore = storeResourceFactory('deleteUsersDiet', undefined);

const setUsersAllergiesStore = storeResourceFactory('setUsersAllergies', undefined);

const usersBulkUploadStore = storeResourceFactory('usersBulkUpload', undefined);

const state = {
  ...userStore.state,
  ...updateFirstLogInStore.state,
  ...updateUsersOfficeStore.state,
  ...deleteUsersDietStore.state,
  ...setUsersAllergiesStore.state,
  ...usersBulkUploadStore.state,
};

const actions = {
  initializeUser: userStore.request(userActions.initializeUser),
  resetUser: userStore.request(userActions.resetUser),
  addUsersDiet: userActions.addUsersDiet,
  updateFirstLogIn: updateFirstLogInStore.request(userActions.updateFirstLogIn),
  deleteUsersDiet: deleteUsersDietStore.request(userActions.deleteUsersDiet),
  updateUsersOffice: updateUsersOfficeStore.request(userActions.updateUsersOffice),
  setUsersAllergies: setUsersAllergiesStore.request(userActions.setUsersAllergies),
  bulkCreateUsers: usersBulkUploadStore.request(userActions.bulkCreateUsers),
};

const mutations = {
  ...userStore.mutations,
  ...updateFirstLogInStore.mutations,
  ...updateUsersOfficeStore.mutations,
  ...deleteUsersDietStore.mutations,
  ...setUsersAllergiesStore.mutations,
  ...userMutations,
  ...usersBulkUploadStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/user/index.js